import React from 'react'
import Button from '../components/Button'
import HaveProjects from '../components/HaveProjects'


const Card = (data) => {
    return (
        <div className='xl:w-1/2 w-full h-full relative rounded-sm overflow-hidden space-y-4 pointer-events-auto'>
            <div className='w-full h-full relative group rounded-sm overflow-hidden'>
                <div className='h-[100vh] w-full rounded-sm overflow-hidden '>
                    <img src={data.src} className='h-full w-full object-cover object-top rounded-sm overflow-hidden' alt="" />
                </div>

                <div className="absolute bottom-0 group-hover:opacity-100 opacity-0 duration-300  bg-gradient-to-b from-transparent to-black/60 w-full h-[10%] z-10">

                </div>

            </div>
            <div>
                <p className='text-sm mb-2 uppercase'>{data.cat}</p>
                <h2 className='xl:text-4xl text-2xl font-bold'>{data.title}</h2>
            </div>
        </div>
    )
}

const cardData = [
    {
        cat: "Website Development",
        title: "Branding for Varallo Group",
        src: "/new-final-data/marketing/VHP.webp"
    },
    {
        cat: "Website Optimization",
        title: "Content Strategy for LCTY",
        src: "/new-final-data/marketing/LCTY.webp"
    },
]



const MarketingSection3 = () => {
    return (
        <>
            <div className='gap-10 xl:py-20 py-10 xl:px-35 px-10 space-y-5 h-full w-full bg-zinc-100 dark:bg-zinc-900 mb-20'>
                <h1 className='text-2xl font-bold'>Brands Born From Stories</h1>

                <div className='h-full text-center xl:text-left w-full overflow-hidden flex justify-between items-center xl:gap-10 gap-20 flex-col xl:flex-row'>
                    {cardData.map((data, index) => (
                        <Card key={index} {...data} />
                    ))}
                </div>
            </div>
            <HaveProjects />
        </>

    )
}

export default MarketingSection3